import React from 'react';
import GuideLayout, { GuideSection, GuideSubSection } from '../layout/GuideLayout';
import BlockRenderer from '../layout/BlockRenderer';

// Renders a page_contents document (content_type "guide") through GuideLayout.
// Shared by the public Tool/Simulator User Guide pages (fetched content) and the
// admin editor's live preview (in-memory, unsaved content).
const GuideContentRenderer = ({ content }) => (
  <GuideLayout
    toolName={content.tool_name}
    toolPath={content.tool_path}
    docVersion={content.doc_version || '1.0'}
    docDate={content.doc_date}
  >
    {(content.sections || []).map((section, i) => (
      <GuideSection key={section.section_id} number={section.number || String(i + 1)} title={section.title}>
        <BlockRenderer blocks={section.blocks} />
        {(section.subsections || []).map((sub) => (
          <GuideSubSection key={sub.section_id} number={sub.number} title={sub.title}>
            <BlockRenderer blocks={sub.blocks} />
          </GuideSubSection>
        ))}
      </GuideSection>
    ))}
  </GuideLayout>
);

export default GuideContentRenderer;
